import { jsx as i, jsxs as s } from "react/jsx-runtime";
import { useMemo as h, useEffect as E } from "react";
import { ConfigContext as T } from "./context2.mjs";
import { FontsStyles as p } from "./fonts.mjs";
import { GlobalStyles as _ } from "./global.mjs";
import { Normalize as c } from "./normalize.mjs";
import { compileTheme as g } from "./compileTheme.mjs";
import { addCompatibilityMode as v } from "./addCompatibilityMode.mjs";
import { isStennTheme as C } from "./isStennTheme.mjs";
import { ThemeProvider as a } from "@mui/material";
import { isDefined as x } from "./types3.mjs";
import { LocaleProvider as P } from "./LocaleProvider.mjs";
const u = ({
  colorMode: r,
  themeOuter: o,
  isCompatibilityMode: m
}) => x(o) && (m && v(o), C(o)) ? r === "light" ? o.light : o.dark : g({
  colorMode: r,
  isCompatibilityMode: m,
  themeOuter: o,
  variant: "default"
}), R = ({
  colorMode: r = "light",
  children: o,
  locale: m,
  withLocaleProvider: d = !0,
  isCompatibilityMode: e,
  debug: n,
  theme: f
}) => {
  const l = h(
    () => ({
      theme: u({ colorMode: r, themeOuter: f, isCompatibilityMode: e })
    }),
    [r, e, f]
  ), { theme: t } = l;
  return E(() => {
    n && (console.log("__CURRENT_THEME_MODE__", r), console.log("__CURRENT_THEME__", t));
  }, [r, n, t]), /* @__PURE__ */ i(T.Provider, { value: l, children: d ? /* @__PURE__ */ i(P, { locale: m, children: /* @__PURE__ */ s(a, { theme: t, children: [
    /* @__PURE__ */ i(c, {}),
    /* @__PURE__ */ i(_, { theme: t }),
    /* @__PURE__ */ i(p, {}),
    o
  ] }) }) : /* @__PURE__ */ s(a, { theme: t, children: [
    /* @__PURE__ */ i(c, {}),
    /* @__PURE__ */ i(_, { theme: t }),
    /* @__PURE__ */ i(p, {}),
    o
  ] }) });
}, V = (r) => /* @__PURE__ */ i(R, { ...r });
export {
  V as ConfigProvider
};
//# sourceMappingURL=index57.mjs.map
